(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scdm-interne-simple"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.getElementById('scdmInterneRacine');
  const form = document.getElementById('partnerSimpleForm');
  if (!root || !form) return;
  document.body.classList.add('int-actif');
  const $ = id => document.getElementById(id);
  let busy = false, ready = false;
  const cache = new WeakMap();
  const message = key => root.dataset[key];
  const value = id => $(id).value.trim();
  form.addEventListener('invalid', () => {
    document.querySelector('#scdmAppro button[data-fermer]')?.click();
    root.scrollIntoView({behavior:'smooth',block:'start'});
  }, true);
  function fail(key) {
    busy = false; ready = false;
    $('partnerError').textContent = message(key);
    $('partnerError').hidden = false;
    root.scrollIntoView({behavior:'smooth',block:'start'});
    sync();
  }
  function sync() {
    const original = $('scdmApproSuite');
    if (!original) return;
    original.hidden = true; original.tabIndex = -1;
    let button = $('partnerSend');
    if (!button) {
      button = document.createElement('button'); button.id = 'partnerSend'; button.type = 'button';
      original.before(button); button.addEventListener('click', prepare);
    }
    button.className = original.className;
    button.disabled = busy || original.disabled;
    button.textContent = message(busy ? 'sending' : 'send');
    for (const id of ['scdmConfig','scdmCommande','scdmAppro']) {
      const host = $(id); if (!host) continue;
      for (const el of host.querySelectorAll('*')) {
        if (!el.children.length && /\d[\d\s.,]*\s*(?:\$|%)/.test(el.textContent)) el.style.display = 'none';
      }
    }
  }
  async function upload(file) {
    if (cache.has(file)) return cache.get(file);
    const data = new FormData();
    data.set('id','52593530405144'); data.set('quantity','1');
    data.set('properties[Fichier]',file);
    data.set('properties[_interne_upload]',crypto.randomUUID());
    const base = window.Shopify?.routes?.root || '/';
    const response = await fetch(base + 'cart/add.js',{method:'POST',body:data});
    if (!response.ok) throw new Error('upload');
    const item = await response.json();
    if (!item.key) throw new Error('key');
    const clean = await fetch(base + 'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity:0})});
    if (!clean.ok) throw new Error('cleanup');
    const url = item.properties?.Fichier;
    if (!url || !/^https:\/\//.test(url)) throw new Error('file');
    cache.set(file,url); return url;
  }
  async function summary(items, reference) {
    const lines = ['DEMANDE INTERNE — Impression SCDM', 'Référence : ' + reference,
      'Nom : ' + value('partnerName'), 'Courriel : ' + value('partnerEmail'),
      'Téléphone : ' + value('partnerPhone'), 'Entreprise : ' + value('partnerCompany'),
      'Numéro de projet : ' + value('partnerProject'),
      'Adresse du projet : ' + value('partnerAddress'), 'Délai demandé : ' + value('partnerDeadline'),
      'Date souhaitée : ' + value('partnerRequiredDate'), 'Note : ' + value('partnerNote'), ''];
    for (let i=0; i<items.length; i++) {
      const d=items[i]; lines.push('DESIGN ' + (i+1) + ' — ' + (d.nom || ''));
      for (const [key,val] of Object.entries(d.props || {})) {
        if (!/prix|price|montant|total|rabais|discount|cost/i.test(key) && !/\d[\d\s.,]*\s*\$/.test(String(val))) lines.push(key + ' : ' + val);
      }
      if (d.fichier instanceof Blob) lines.push('Fichier : ' + await upload(d.fichier));
      else if (d.lienFichier && /^https:\/\//.test(d.lienFichier)) lines.push('Fichier : ' + d.lienFichier);
      else if (d.aFichier) throw new Error('missing-file');
      if (d.epreuve && /^data:image\//.test(d.epreuve)) {
        const blob = await (await fetch(d.epreuve)).blob();
        lines.push('Épreuve : ' + await upload(new File([blob],'epreuve-'+(i+1)+'.png',{type:blob.type})));
      }
      lines.push('');
    }
    lines.push('INTERNE UNIQUEMENT — AUCUNE FACTURATION — AUCUN PAIEMENT');
    return lines.join('\n');
  }
  async function prepare() {
    if (busy) return;
    if (!form.reportValidity()) return;
    const items = window.SCDM?.commande || [];
    if (!items.length) return fail('empty');
    const approval = $('scdmApproSuite');
    if (!approval || approval.disabled) return fail('approve');
    busy = true; $('partnerError').hidden = true; sync();
    try {
      const reference = 'INT-' + Date.now() + '-' + crypto.randomUUID().slice(0,8);
      const body = await summary(items.slice(), reference);
      if (body.length > 20000) return fail('large');
      $('partnerReference').value = reference;
      $('partnerBody').value = body;
      ready = true;
      form.requestSubmit($('partnerNativeSubmit'));
      setTimeout(() => { ready=false; busy=false; sync(); }, 15000);
    } catch (error) { fail('failure'); }
  }
  form.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.tagName !== 'TEXTAREA') {
      event.preventDefault();
      prepare();
    }
  });
  form.addEventListener('submit', event => {
    if (ready && value('partnerReference') && value('partnerBody')) return;
    event.preventDefault();
    prepare();
  });
  sync(); setInterval(sync, 500);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scdm-materials-scroll"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('scdm-materials-banner')) {
  customElements.define('scdm-materials-banner', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.video = this.querySelector('video');
        this.frame = this.querySelector('.scdm-materials-banner__frame');
        if (!this.video || !this.frame) return;
        const signal = this.controller.signal;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.volume = 0;
        this.root = this.parentElement;
        while (this.root && !/(auto|scroll)/.test(getComputedStyle(this.root).overflowY)) this.root = this.root.parentElement;
        this.root = this.root || document.scrollingElement;
        this.sync = () => {
          if (!this.video || !Number.isFinite(this.video.duration)) return;
          const area = this.getBoundingClientRect();
          const frameHeight = this.frame.getBoundingClientRect().height;
          const rootTop = this.root === document.scrollingElement ? 0 : this.root.getBoundingClientRect().top;
          const span = Math.max(1, area.height - frameHeight);
          const progress = Math.max(0, Math.min(1, (rootTop - area.top) / span));
          const target = progress * (this.video.duration - 0.04);
          if (!this.video.seeking && Math.abs(this.video.currentTime - target) > 0.018) {
            this.video.currentTime = target;
          }
        };
        this.ready = () => {
          if (!Number.isFinite(this.video.duration) || this.video.duration <= 0) return;
          this.setAttribute('data-ready', '');
          this.sync();
        };
        this.tick = () => {
          this.raf = 0;
          if (!this.isConnected || !this.visible || document.hidden) return;
          this.sync();
          this.raf = requestAnimationFrame(this.tick);
        };
        this.restart = () => {
          if (!this.raf && this.visible && !document.hidden) this.raf = requestAnimationFrame(this.tick);
          this.ready();
        };
        for (const event of ['loadedmetadata','loadeddata','canplay','progress']) this.video.addEventListener(event,this.ready,{signal});
        this.video.addEventListener('seeked',this.sync,{signal});
        this.video.addEventListener('play',()=>this.video.pause(),{signal});
        this.video.addEventListener('error',()=>this.removeAttribute('data-ready'),{signal});
        this.root.addEventListener('scroll',this.sync,{passive:true,signal});
        document.addEventListener('scroll',this.sync,{passive:true,capture:true,signal});
        window.addEventListener('resize',this.sync,{passive:true,signal});
        window.addEventListener('pageshow',this.restart,{signal});
        document.addEventListener('visibilitychange',this.restart,{signal});
        this.observer = new IntersectionObserver(entries=>{
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.restart();
          else { cancelAnimationFrame(this.raf); this.raf = 0; }
        },{root:this.root === document.scrollingElement ? null : this.root,rootMargin:'100px'});
        this.observer.observe(this);
        this.ready();
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scdm-materiaux-cinema"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('scdm-materials-cinema')) {
  customElements.define('scdm-materials-cinema', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.video = this.querySelector('video');
        this.frame = this.querySelector('.scdm-materials-cinema__frame');
        if (!this.video || !this.frame) return;
        const signal = this.controller.signal;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.volume = 0;
        this.root = this.parentElement;
        while (this.root && !/(auto|scroll)/.test(getComputedStyle(this.root).overflowY)) this.root = this.root.parentElement;
        this.root = this.root || document.scrollingElement;
        const initialRootTop = this.root === document.scrollingElement ? 0 : this.root.getBoundingClientRect().top;
        this.startOffset = Math.max(0, this.getBoundingClientRect().top - initialRootTop + this.root.scrollTop);
        this.sync = () => {
          if (!this.video || !Number.isFinite(this.video.duration)) return;
          const area = this.getBoundingClientRect();
          const frameHeight = this.frame.getBoundingClientRect().height;
          const rootTop = this.root === document.scrollingElement ? 0 : this.root.getBoundingClientRect().top;
          const span = Math.max(140, Math.min(420, frameHeight * 0.5));
          const progress = Math.max(0, Math.min(1, (rootTop - area.top + this.startOffset) / span));
          const target = progress * (this.video.duration - 0.04);
          if (!this.video.seeking && Math.abs(this.video.currentTime - target) > 0.018) {
            this.video.currentTime = target;
          }
        };
        this.ready = () => {
          if (!Number.isFinite(this.video.duration) || this.video.duration <= 0) return;
          this.setAttribute('data-ready', '');
          this.sync();
        };
        this.tick = () => {
          this.raf = 0;
          if (!this.isConnected || !this.visible || document.hidden) return;
          this.sync();
          this.raf = requestAnimationFrame(this.tick);
        };
        this.restart = () => {
          if (!this.raf && this.visible && !document.hidden) this.raf = requestAnimationFrame(this.tick);
          this.ready();
        };
        for (const event of ['loadedmetadata','loadeddata','canplay','progress']) this.video.addEventListener(event,this.ready,{signal});
        this.video.addEventListener('seeked',this.sync,{signal});
        this.video.addEventListener('play',()=>this.video.pause(),{signal});
        this.video.addEventListener('error',()=>this.removeAttribute('data-ready'),{signal});
        this.root.addEventListener('scroll',this.sync,{passive:true,signal});
        document.addEventListener('scroll',this.sync,{passive:true,capture:true,signal});
        window.addEventListener('resize',this.sync,{passive:true,signal});
        window.addEventListener('pageshow',this.restart,{signal});
        document.addEventListener('visibilitychange',this.restart,{signal});
        this.observer = new IntersectionObserver(entries=>{
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.restart();
          else { cancelAnimationFrame(this.raf); this.raf = 0; }
        },{root:this.root === document.scrollingElement ? null : this.root,rootMargin:'100px'});
        this.observer.observe(this);
        this.ready();
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.raf);
      this.raf = 0;
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
